import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FaVideo } from 'react-icons/fa';
import MeetingWindow from '../components/VideoCall/MeetingWindow';
import videoCallService from '../services/videoCallService';
import './GuestJoinPage.css';

const GuestJoinPage = () => {
    const { token } = useParams();
    const [meetingInfo, setMeetingInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [expired, setExpired] = useState(false);
    const [name, setName] = useState('');
    const [joining, setJoining] = useState(false);
    const [joinError, setJoinError] = useState(null);
    const [callData, setCallData] = useState(null);
    const [callEnded, setCallEnded] = useState(false);

    useEffect(() => {
        const fetchMeeting = async () => {
            try {
                const res = await videoCallService.getGuestMeeting(token);
                setMeetingInfo(res.data.meeting);
            } catch (err) {
                setExpired(true);
            } finally {
                setLoading(false);
            }
        };
        fetchMeeting();
    }, [token]);

    const handleJoin = async () => {
        if (!name.trim()) return;
        setJoining(true);
        setJoinError(null);
        try {
            const res = await videoCallService.joinAsGuest(token, name.trim());
            const tokensWithName = { ...res.data.tokens, guestName: res.data.guestName };
            setCallData({ meeting: res.data.meeting, tokens: tokensWithName });
        } catch (err) {
            setJoinError(err?.message || 'Failed to join. Please try again.');
        } finally {
            setJoining(false);
        }
    };

    const handleCallClose = () => {
        setCallData(null);
        setCallEnded(true);
    };

    if (loading) {
        return (
            <div className="guest-join-page">
                <div className="guest-join-card">
                    <p style={{ color: '#a0aec0' }}>Loading…</p>
                </div>
            </div>
        );
    }

    if (expired) {
        return (
            <div className="guest-join-page">
                <div className="guest-join-card">
                    <p className="guest-join-expired">This invite link has expired or is invalid.</p>
                </div>
            </div>
        );
    }

    if (callEnded) {
        return <div className="guest-call-ended">The call has ended. You may close this tab.</div>;
    }

    if (callData) {
        return (
            <MeetingWindow
                meeting={callData.meeting}
                tokens={callData.tokens}
                onClose={handleCallClose}
                startJoined={true}
            />
        );
    }

    return (
        <div className="guest-join-page">
            <div className="guest-join-card">
                <div className="guest-join-icon">
                    <FaVideo />
                </div>
                <h2>{meetingInfo?.title || 'Join Meeting'}</h2>
                {meetingInfo?.host?.name && (
                    <p className="host-name">Hosted by {meetingInfo.host.name}</p>
                )}

                <input
                    className="guest-name-input"
                    type="text"
                    placeholder="Your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
                    maxLength={50}
                    autoFocus
                />

                <button
                    className="guest-join-btn"
                    onClick={handleJoin}
                    disabled={joining || !name.trim()}
                >
                    {joining ? 'Joining…' : 'Join as Guest'}
                </button>

                {joinError && <p className="guest-join-error">{joinError}</p>}
            </div>
        </div>
    );
};

export default GuestJoinPage;
